<template>
  <div class="aspectration" v-bind:style="style">
    <transition name="fade">
      <img
        :src="src"
        v-on:load="onLoaded"
        v-show="loaded"
      />
    </transition>
  </div>
</template>

<script>

export default {
  props: ["src", "width", "height"],
  data() {
    return {
      loaded: false,
      style: {
        "--aspect-ratio": this.width / this.height
      }
    };
  },
  mounted() {},
  methods: {
    onLoaded() {
      this.$emit('loaded')
      this.loaded = true;
    }
   
  }
};
</script>

<style scoped>
img {
  width: 100%;
  object-fit: cover;
}

.fade-enter-active {
  transition: opacity 0.1s ease-in-out;
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}

.aspectration {
  position: relative;
  height: 0;
  width: 100%;
  background-color: #fafafa;
}

.aspectration[style*="--aspect-ratio"] {
  padding-top: calc(100% / (var(--aspect-ratio)));
}

.aspectration * {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageWithLoading.vue